<div class="modal-header items-center" style="padding-bottom: 5px;">
    <h3 class="modal-title">New Version Available</h3>
    <button class="" type="button" (click)="closeModal()" aria-label="Close"><span aria-hidden="true">
        <i class="fas fa-times"></i>
    </span></button>
</div>
<div class="modal-body rounded-b-lg" style="padding-top: 5px;">
    <p>Please reload page to load New Version!</p> 
    <button class="mt-2 py-2 px-3 bg-blue-700 text-white rounded-lg" type="button" (click)='pageReload()'>
        <i class="fas fa-cloud-download-alt"></i> Load New Version
    </button>
    <button class="text-blue-700 mt-2 font-normal text-sm underline" type="button" (click)='pageReload(true)'> Vew Release Notes</button>
</div>
